//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';
import { Badge } from 'unison';


export const PendingIconOverlay: React.FunctionComponent = () => {
  return (
    <IconOverlay>
      <PendingIcon className='di di-requestrights-pending-32px' />
      <PendingIconTitle>Pending</PendingIconTitle>
    </IconOverlay>
  );
};

const EIGHTY_PERCENT_OPACITY = 'CC';

const IconOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) =>
    theme.colors.gray9 + EIGHTY_PERCENT_OPACITY};
`;

const PendingIcon = styled.div`
  opacity: 1;
  color: ${({ theme }) => theme.colors.yellow2};
  margin-bottom: ${({ theme }) => theme.spacings[2]};

  && {
    font-size: 40px;
  }
`;

const PendingIconTitle = styled(Badge)`
  && {
    background-color: ${({ theme }) => theme.colors.yellow2};
  }
`;
